import { useEffect, useState } from 'react'

const events = [
  'DOMMouseScroll',
  'keydown',
  'keypress',
  'mousedown',
  'mousemove',
  'mousewheel',
  'MSPointerMove',
  'scroll',
  'touchmove',
  'touchstart',
]

export default function useIdle(timeout = 1000) {
  const [isInactive, setIsInactive] = useState(false)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout

    const handleEvent = () => {
      clearTimeout(timeoutId)

      setIsInactive(false)
      timeoutId = setTimeout(() => setIsInactive(true), timeout)
    }

    events.forEach(event => window.addEventListener(event, handleEvent))
    timeoutId = setTimeout(() => setIsInactive(true), timeout)

    return () => {
      clearTimeout(timeoutId)

      events.forEach(event => window.removeEventListener(event, handleEvent))
    }
  }, [])

  return isInactive
}
